/** Ponto de quebra da versão mobile (Figma: Mobile/Profissionais), o mesmo do CSS (48rem). */
export const CARGA_TRABALHO_MOBILE_QUERY = "(max-width: 768px)";

/**
 * Gantt do Fornecedor: além da largura de celular, usa o layout mobile em celular na paisagem
 * (altura baixa), onde as 3 colunas fixas da visão por Obras deixavam quase nada para a linha
 * do tempo. Mantém "max-width" na consulta para o modo de impressão continuar usando o desktop.
 */
export const CARGA_FORNECEDOR_COMPACT_QUERY =
  "(max-width: 768px), (max-height: 500px) and (orientation: landscape)";
